import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "../reducers/userReducer";
import languageReducer from "../languageReducer";

export const rootReducer = combineReducers({
  user: userReducer,
  language:languageReducer
});
